<div class="aca-admin aca-jobs">
  <aca-page-header [bare]="embedded" icon="schedule_send" [title]="'DMS.JOBS.TITLE' | translate" [subtitle]="'DMS.JOBS.SUBTITLE' | translate">
    <button type="button" class="aca-jobs__add" (click)="add()"><mat-icon>add_task</mat-icon>{{ 'DMS.JOBS.ADD' | translate }}</button>
  </aca-page-header>

  <!-- sidecar availability + mail status -->
  <div class="aca-jobs__banner" *ngIf="serviceUp() === false">
    <mat-icon>cloud_off</mat-icon>
    <span>{{ 'DMS.JOBS.SERVICE_DOWN' | translate }}</span>
  </div>
  <div class="aca-jobs__banner aca-jobs__banner--info" *ngIf="serviceUp() === true && !mailOn()">
    <mat-icon>mail_outline</mat-icon>
    <span>{{ 'DMS.JOBS.MAIL_OFF' | translate }}</span>
  </div>

  <div class="aca-jobs__tabs">
    <button type="button" class="aca-jobs__tab" [class.aca-jobs__tab--on]="tab === 'jobs'" (click)="tab = 'jobs'">
      <mat-icon>schedule</mat-icon>{{ 'DMS.JOBS.TAB_JOBS' | translate }} ({{ defs().length }})
    </button>
    <button type="button" class="aca-jobs__tab" [class.aca-jobs__tab--on]="tab === 'history'" (click)="tab = 'history'">
      <mat-icon>history</mat-icon>{{ 'DMS.JOBS.TAB_HISTORY' | translate }} ({{ runs().length }})
    </button>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading()" />

  <aca-page-state
    *ngIf="failed()"
    state="error"
    [title]="'DMS.JOBS.LOAD_FAIL' | translate"
    [message]="failed()"
    [actionLabel]="'DMS.UI.324E7E' | translate"
    (action)="load()"
  />

  <!-- ── jobs table ─────────────────────────────────────────────────────── -->
  <section class="aca-jobs__card" *ngIf="!failed() && tab === 'jobs'">
    <aca-page-state
      *ngIf="!loading() && !defs().length"
      state="empty"
      icon="schedule"
      [title]="'DMS.JOBS.EMPTY' | translate"
      [message]="'DMS.JOBS.EMPTY_HINT' | translate"
      [actionLabel]="'DMS.JOBS.ADD' | translate"
      (action)="add()"
    />

    <div class="aca-jobs__tablewrap" *ngIf="defs().length">
      <table class="aca-jobs__table">
        <thead>
          <tr>
            <th class="aca-jobs__th aca-jobs__th--name">{{ 'DMS.JOBS.COL_NAME' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_CONDITION' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_SCHEDULE' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_ACTION' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_NEXTRUN' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_LASTRUN' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_ENABLED' | translate }}</th>
            <th class="aca-jobs__th aca-jobs__th--actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr class="aca-jobs__row" *ngFor="let job of defs(); trackBy: trackById" [class.aca-jobs__row--off]="!job.enabled">
            <td class="aca-jobs__td aca-jobs__td--name">
              <span class="aca-jobs__jobicon"
                ><mat-icon>{{ job.enabled ? 'event_repeat' : 'event_busy' }}</mat-icon></span
              >
              <span class="aca-jobs__namebox">
                <span class="aca-jobs__name">{{ job.name }}</span>
                <span class="aca-jobs__dryrun" *ngIf="job.dryRun">{{ 'DMS.JOBS.DRYRUN_BADGE' | translate }}</span>
                <span class="aca-jobs__running" *ngIf="stateOf(job)?.running">{{ 'DMS.JOBS.RUNNING' | translate }}</span>
              </span>
            </td>
            <td class="aca-jobs__td aca-jobs__td--cond">
              <span class="aca-jobs__rule" *ngFor="let rule of job.condition?.rules">{{ ruleLabel(rule) }}</span>
              <span class="aca-jobs__rule aca-jobs__rule--extra" *ngIf="job.condition?.extraQuery">+ AFTS</span>
            </td>
            <td class="aca-jobs__td">{{ scheduleLabel(job) }}</td>
            <td class="aca-jobs__td">
              <span class="aca-jobs__action">{{ actionLabel(job.action?.type) }}</span>
            </td>
            <td class="aca-jobs__td">{{ dateLabel(stateOf(job)?.nextRun) }}</td>
            <td class="aca-jobs__td">
              <ng-container *ngIf="lastRun(job) as run">
                <span class="aca-jobs__runres" [class.aca-jobs__runres--err]="run.errors?.length" [matTooltip]="runResult(run)">
                  {{ dateLabel(run.finishedAt) }} · {{ run.processed }}/{{ run.matched }}
                  <mat-icon *ngIf="run.errors?.length">error_outline</mat-icon>
                </span>
              </ng-container>
              <span *ngIf="!lastRun(job)">—</span>
            </td>
            <td class="aca-jobs__td">
              <mat-slide-toggle
                [checked]="job.enabled"
                [disabled]="busyId() === job.id"
                (change)="toggle(job)"
                [matTooltip]="'DMS.JOBS.TOGGLE' | translate"
              />
            </td>
            <td class="aca-jobs__td aca-jobs__td--actions">
              <button
                mat-icon-button
                [matMenuTriggerFor]="jobMenu"
                [matTooltip]="'DMS.USERS_PAGE.6D5E7B' | translate"
                [attr.aria-label]="'DMS.USERS_PAGE.6D5E7B' | translate"
              >
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #jobMenu="matMenu">
                <button mat-menu-item (click)="runNow(job)" [disabled]="busyId() === job.id">
                  <mat-icon>play_arrow</mat-icon><span>{{ 'DMS.JOBS.RUN_NOW' | translate }}</span>
                </button>
                <button mat-menu-item (click)="edit(job)">
                  <mat-icon>edit</mat-icon><span>{{ 'DMS.JOBS.EDIT' | translate }}</span>
                </button>
                <button mat-menu-item (click)="remove(job)" [disabled]="busyId() === job.id">
                  <mat-icon>delete</mat-icon><span>{{ 'DMS.JOBS.DELETE' | translate }}</span>
                </button>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- ── run history ────────────────────────────────────────────────────── -->
  <section class="aca-jobs__card" *ngIf="!failed() && tab === 'history'">
    <aca-page-state
      *ngIf="runsLoaded() && !runs().length"
      state="empty"
      icon="history"
      [title]="'DMS.JOBS.NO_RUNS' | translate"
      [message]="'DMS.JOBS.NO_RUNS_HINT' | translate"
    />

    <div class="aca-jobs__tablewrap" *ngIf="runs().length">
      <table class="aca-jobs__table">
        <thead>
          <tr>
            <th class="aca-jobs__th aca-jobs__th--name">{{ 'DMS.JOBS.COL_JOB' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_WHEN' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_TRIGGER' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_MATCHED' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_PROCESSED' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_ERRORS' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_DURATION' | translate }}</th>
            <th class="aca-jobs__th">{{ 'DMS.JOBS.COL_EMAILED' | translate }}</th>
            <th class="aca-jobs__th aca-jobs__th--actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr class="aca-jobs__row aca-jobs__row--clickable" *ngFor="let run of runs(); trackBy: trackByRun" (click)="viewRun(run)">
            <td class="aca-jobs__td aca-jobs__td--name">{{ run.jobName }}</td>
            <td class="aca-jobs__td">{{ dateLabel(run.finishedAt || run.startedAt) }}</td>
            <td class="aca-jobs__td">
              <span class="aca-jobs__chip" [class.aca-jobs__chip--manual]="run.triggeredBy?.startsWith('manual')">
                {{ run.triggeredBy?.startsWith('manual') ? ('DMS.JOBS.TRIG_MANUAL' | translate) : ('DMS.JOBS.TRIG_SCHED' | translate) }}
              </span>
              <span class="aca-jobs__dryrun" *ngIf="run.dryRun">{{ 'DMS.JOBS.DRYRUN_BADGE' | translate }}</span>
            </td>
            <td class="aca-jobs__td">{{ run.matched }}</td>
            <td class="aca-jobs__td">{{ run.processed }}</td>
            <td class="aca-jobs__td">
              <span class="aca-jobs__errcount" [class.aca-jobs__errcount--some]="run.errors?.length" [matTooltip]="run.errors?.[0]?.message">
                {{ run.errors?.length ?? 0 }}
              </span>
            </td>
            <td class="aca-jobs__td">{{ run.durationMs / 1000 | number: '1.0-1' }} s</td>
            <td class="aca-jobs__td">
              <mat-icon *ngIf="run.emailed?.length" [matTooltip]="run.emailed?.join(', ')">mail</mat-icon>
              <span *ngIf="!run.emailed?.length">—</span>
            </td>
            <td class="aca-jobs__td aca-jobs__td--actions">
              <button
                type="button"
                class="aca-jobs__viewrun"
                [matTooltip]="'DMS.JOBS.VIEW_RUN' | translate"
                [attr.aria-label]="'DMS.JOBS.VIEW_RUN' | translate"
                (click)="$event.stopPropagation(); viewRun(run)"
              >
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
